import { render } from "./Kwismaster.vue?vue&type=template&id=eaf0b580&scoped=true"
import script from "./Kwismaster.vue?vue&type=script&lang=js"
export * from "./Kwismaster.vue?vue&type=script&lang=js"

import "./Kwismaster.vue?vue&type=style&index=0&id=eaf0b580&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf0b580"]])

export default __exports__